import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";

const pathMap = {
	[Locale.cs]: "vice-o-produktu" as const,
} satisfies LocalizedString;

export function getMoreAboutProductAnchor(tenant: Tenant): string {
	return pathMap[tenant.locale];
}
